import Signomatic from "@/signomatic/containers/signomatic"
import componentShell from "./shell"

export default componentShell(Signomatic)
